import React, { useMemo, useEffect, useState } from 'react'
import {
    Typography, Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, Select, MenuItem, Grid, Snackbar, Alert, DialogContentText, Autocomplete,
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import MaterialReactTable from 'material-react-table';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import RefreshIcon from '@mui/icons-material/Refresh';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

import ButtonGroup from '@mui/material/ButtonGroup';
import { Tooltip, IconButton } from "@mui/material";
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import borders from "assets/mavric-theme/base/borders";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import ProbeStatus_table from '../Probes/ProbeStatus_table';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const { primary, secondary, text, tableRow, transparent, white } = colors;
const { size } = typography;
const { borderRadius } = borders;
const ITEM_HEIGHT = 48;


export default function BilledCustomers({ muiBilledCustTableKey, billedData, productTypeList, productType, isAccounting,
    isSalesAdmin, isSupport, probeStatusList, showProbeTable,
    deleteAlertMsg, pageAlertType, hasChangesForBilled, alertState, showDeleteAlert, setSelectedBilledCustomers,
    openBilledCustDialog, openBilledCustViewDialog, openBilledCustConfirmationDialog, confirmDeleteOpenBilledCust,
    selectedRowBilledCust, deleteMessageConfirmBilledCust, deleteMessageConfirmTitleBilledCust, setSelectedRowBilledCust,

    handleBilledCustClickOpen, handleClickOpenBilledCustomerDetailView, handleBilledCustCloseDialog,
    handleCloseViewBilledCustomerDialog, handleCloseBilledCustConfirmation, handleBilledCustChange, handleBilledCustAccountTypeChange,
    handleBilledCustAccountStatusChange,
    handleBilledCustProductTypeChange, handleSaveBilledCust, handleDeleteBilledCustomer,
    handleDeleteBilledCustAlertClose, handleConfirmCloseBilledCust, handleDeleteYesBilledCust,
    handleDeleteNoBilledCust, resetBilledCustFilters, handleOpenBilledCustConfirmation,
    handleClickOpenCustomerDetailView, getProbesByCustomerId }) {


    const columns = useMemo(

        () => [
            {
                accessorKey: 'customer_id',
                header: 'Customer ID',
                id: 'customer_id',
                size: 120,
                Filter: ({ header }) => (
                    <Autocomplete
                        size="small"
                        options={customerIdOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option}
                        renderOption={(props, option, { selected }) => (
                            <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option}</MenuItem>
                        )}
                        style={{ width: 130 }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" placeholder="Customer ID" />
                        )}
                        sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
                        onChange={(event, value) =>
                            header.column.setFilterValue(value)}
                        clearIcon={<HighlightOffIcon fontSize="small" />}
                        ListboxProps={{
                            sx: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                            }
                        }}
                    />
                ),
                filterFn: 'customerIdFilterFn',

            },
            {
                header: 'Customer Name',
                accessorKey: 'org_name',
                filter: 'equals',
                id: 'org_name',
                size: 150,
                Filter: ({ header }) => (
                    <Autocomplete
                        // multiple
                        size="small"
                        options={orgNameOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option}
                        renderOption={(props, option, { selected }) => (
                            <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option}</MenuItem>
                        )}
                        style={{ width: 150 }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" placeholder="Customer Name" />
                        )}
                        sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
                        onChange={(event, value) =>
                            header.column.setFilterValue(value)}
                        clearIcon={<HighlightOffIcon fontSize="small" />}
                        ListboxProps={{
                            sx: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                            }
                        }}
                    />
                ),
                filterFn: 'customerNameFilterFn',

            },
            {
                accessorKey: 'product_type',
                header: 'Product Type',
                id: 'product_type',
                size: 120,
                Filter: ({ header }) => (
                    <Autocomplete
                        size="small"
                        options={productTypeOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option}
                        renderOption={(props, option, { selected }) => (
                            <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option} </MenuItem>
                        )}
                        style={{ width: 140 }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" placeholder="Product Type" />
                        )}
                        sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
                        onChange={(event, value) =>
                            header.column.setFilterValue(value)}
                        clearIcon={<HighlightOffIcon fontSize="small" />}
                        ListboxProps={{ sx: { maxHeight: ITEM_HEIGHT * 4.5, } }}
                    />
                ),
                filterFn: 'productTypeFilterFn',

            },
            // {
            //   accessorKey: 'sso_auth_provider',
            //   header: 'SSO Provider',
            //   size: 100,
            //   enableColumnFilter: false,
            // },
            // {
            //   accessorKey: 'sso_enabled',
            //   header: 'Single-Sign-On',
            //   size: 120,
            //   enableColumnFilter: false,
            //   Cell: ({ cell }) => {
            //     const value = cell.getValue();
            //     return (
            //       <span
            //         style={{
            //           color: value ? secondary.main : text.disabled, // Set color based on boolean value
            //         }}
            //       >
            //         {value ? 'Enabled' : 'Disabled'}
            //       </span>
            //     );
            //   },
            // },
            // {
            //   header: 'Probes',
            //   accessorFn: (row) => '0',
            //   Cell: ({ cell, row }) => (
            //     <Tooltip title="Click to view Probes" aria-label="Click to view Probes">
            //       <Button
            //         variant="text"
            //         // disableElevation={true} 
            //         sx={{ backgroundColor: transparent.main, }}
            //         onClick={() => {
            //           setSelectedProbeGrpRow(row.original.probe_group_list);
            //           setOpenProbeGrpCount(true);
            //         }}
            //       >
            //         {cell.getValue()}
            //       </Button>
            //     </Tooltip>
            //   ),
            //   id: 'probe_group_list',
            //   enableColumnFilter: false,
            // },

            {
                accessorKey: 'is_active',
                header: 'Status',
                id: 'status',
                size: 120,
                Filter: ({ header }) => (
                    <Autocomplete
                        size="small"
                        // options={statusOptions}
                        options={['Active', 'Inactive']}
                        getOptionLabel={(option) => option}
                        renderOption={(props, option) => (
                            <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}>
                                {option}
                            </MenuItem>
                        )}
                        style={{ width: 120 }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" placeholder="Status" />
                        )}
                        sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
                        onChange={(event, value) => {
                            const boolVal = value === 'Active' ? true : value === 'Inactive' ? false : null;
                            header.column.setFilterValue(boolVal);
                        }}
                        clearIcon={<HighlightOffIcon fontSize="small" />}
                        ListboxProps={{ sx: { maxHeight: ITEM_HEIGHT * 4.5 } }}
                    />
                ),

                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    return (
                        <span style={{ color: value ? text.main : text.disabled }}>
                            {value ? 'ACTIVE' : 'INACTIVE'}
                        </span>
                    );
                },
                filterFn: 'statusFilterFn',

            },

            // {
            //     accessorKey: 'act_type',
            //     header: 'Account Type',
            //     id: 'act_type',
            //     size: 110,
            //     enableColumnFilter: false,
            //     // Filter: ({ header }) => (
            //     //   <Autocomplete
            //     //     size="small"
            //     //     options={accountTypeOptions}
            //     //     disableCloseOnSelect
            //     //     getOptionLabel={(option) => option}
            //     //     renderOption={(props, option, { selected }) => (
            //     //       <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}>
            //     //         {option}
            //     //       </MenuItem>
            //     //     )}
            //     //     style={{ width: 150 }}
            //     //     renderInput={(params) => (
            //     //       <TextField {...params} variant="outlined" placeholder="Account Type" />
            //     //     )}
            //     //     sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
            //     //     onChange={(event, value) => header.column.setFilterValue(value)}
            //     //     clearIcon={<HighlightOffIcon fontSize="small" />}
            //     //     ListboxProps={{ sx: { maxHeight: ITEM_HEIGHT * 4.5 } }}
            //     //   />
            //     // ),
            //     // filterFn: 'accountTypeFilterFn',
            // },

            {
                accessorKey: 'created_by',
                header: 'Created By',
                id: 'created_by',
                size: 120,
                enableColumnFilter: false,
            },
            {
                accessorKey: 'updated_by',
                header: 'Updated By',
                id: 'updated_by',
                size: 120,
                enableColumnFilter: false,
            },
            {
                accessorKey: 'account_activation_updated_on',
                header: 'Activation Time',
                id: 'account_activation_updated_on',
                size: 150,
                enableColumnFilter: false,
                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    return value ? new Date(value).toLocaleString() : '-';
                },
                sortDescFirst: true
            },
            {
                accessorKey: 'last_modified_on',
                header: 'Modified Time',
                id: 'last_modified_on',
                size: 150,
                enableColumnFilter: false,
                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    return value ? new Date(value).toLocaleString() : '-';
                },
            },

        ],
        [],
    );

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [orgNameOptions, setOrgNameOptions] = useState([]);
    const [customerIdOptions, setCustomerIdOptions] = useState([]);
    const [productTypeOptions, setProductTypeOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);
    const { vertical, horizontal } = alertState;
    // const { openAlert, alertSeverity, alertMessage, vertical, horizontal } = alertState;

    useEffect(() => {
        if (Array.isArray(billedData) && billedData.length > 0) {
            prepareBilledCustomerData(billedData);
        }
    }, [billedData]);

    const prepareBilledCustomerData = (data) => {
        let updtdOrgNameOptions = orgNameOptions;
        let updtdCustIdOptions = customerIdOptions;
        let updtdProdTypeOptions = productTypeOptions;
        let updtdStatusOptions = statusOptions;
        // let updtdAccountTypeOptions = accountTypeOptions;

        data.map(row => {
            const isDuplicateOrgName = updtdOrgNameOptions.includes(row.org_name);
            const isDuplicateCustId = updtdCustIdOptions.includes(row.customer_id);
            const isDuplicateProdType = updtdProdTypeOptions.includes(row.product_type);
            const status = row.is_active ? 'ACTIVE' : 'INACTIVE';
            const isDuplicateStatus = updtdStatusOptions.includes(status);
            // const accountType = row.row.act_type ? row.row.act_type.toUpperCase() : undefined;
            // const isDuplicateAccountType = updtdAccountTypeOptions.includes(accountType);
            // const isDuplicateAccountType = updtdAccountTypeOptions.includes(row.act_type);

            if (!isDuplicateOrgName) {
                updtdOrgNameOptions.push(row.org_name);
            }

            if (!isDuplicateCustId) {
                updtdCustIdOptions.push(String(row.customer_id));
            }

            if (!isDuplicateProdType) {
                updtdProdTypeOptions.push(row.product_type);
            }

            if (!isDuplicateStatus) {
                updtdStatusOptions.push(status);
            }

            // if (accountType && !isDuplicateAccountType) {
            //   updtdAccountTypeOptions.push(accountType);
            // }

            // if (!isDuplicateAccountType) {
            //   updtdAccountTypeOptions.push(row.act_type);
            // }

        });
        setOrgNameOptions(updtdOrgNameOptions.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
        setCustomerIdOptions(updtdCustIdOptions.sort(((a, b) => parseInt(a) - parseInt(b))));
        setProductTypeOptions(updtdProdTypeOptions.sort());
        setStatusOptions(updtdStatusOptions.sort());
        // setAccountTypeOptions(updtdAccountTypeOptions.sort());

    }


    return (
        <div>
            {billedData.length === 0 ? <Typography sx={{ display: 'flex', justifyContent: 'center', color: '#8080807a', }}>No Data Found</Typography> :
                <MaterialReactTable
                    key={muiBilledCustTableKey}
                    columns={columns}
                    // data={custDataList}
                    data={billedData}

                    muiTableToolbarAlertBannerProps={{ sx: { display: 'none' } }}
                    muiTablePaperProps={{ sx: { boxShadow: 'none', backgroundColor: primary.main } }}
                    muiTableBodyRowProps={({ row }) => ({
                        hover: true,
                        sx: {
                            color: text.main,
                            align: 'center',
                            '&:nth-of-type(odd)': {
                                backgroundColor: tableRow.dark,
                                border: 0,
                            },
                            '&:nth-of-type(even)': {
                                background: tableRow.light,
                            },
                            // hide last border
                            '&:last-child td, &:last-child th': {
                                border: 0,
                            },
                            '&:hover td': {
                                background: tableRow.hover,
                            },
                        },
                    })}
                    //muiTableBodyProps={{sx:{boxShadow: 'none'}}}
                    muiTableBodyCellProps={{ sx: { border: 'none', color: text.main, align: 'center', boxShadow: 'none', padding: '4px 8px', } }}
                    muiTableProps={{ sx: { backgroundColor: primary.main, color: text.main, boxShadow: 'none' } }}
                    // muiTableToolbarTopProps={{ sx: {backgroundColor: primary.main, boxShadow: 'none', minHeight: 0} }}
                    // muiTableToolbarBottomProps={{ sx: {backgroundColor: primary.main, boxShadow: 'none'} }}
                    muiTopToolbarProps={{ sx: { backgroundColor: primary.main, boxShadow: 'none', minHeight: 0 } }}
                    muiBottomToolbarProps={{ sx: { backgroundColor: primary.main, boxShadow: 'none' } }}
                    muiTableHeadRowProps={{ sx: { backgroundColor: primary.main, color: text.main, textAlign: 'center' }, }}
                    muiTableHeadCellProps={{ sx: { borderBottom: 0, verticalAlign: 'none', boxShadow: 'none', align: 'center', color: text.main } }}
                    // enableToolbarTop={false}
                    // enableColumnFilters={true}
                    enableRowSelection={(isAccounting) ? true : false}
                    // enableRowSelection={isAccounting}

                    enableColumnActions={false}
                    enableColumnOrdering={false}
                    enablePinning={false}
                    enableSelectAll={false}
                    enableStickyHeader={false}
                    enableClickToCopy={false}

                    // enableSorting={false}
                    enableRowActions
                    positionPagination="bottom"
                    enableToolbarInternalActions={false}
                    initialState={{
                        density: 'compact',
                        showColumnFilters: true,
                        boxShadow: 'none',
                        pagination: { pageSize: 10, pageIndex: 0, pageCount: -1, },
                        sorting: [
                            {
                                id: 'account_activation_updated_on', //sort by account_activation_updated_on by default on page load
                                desc: true,
                            }
                        ],
                    }}
                    positionActionsColumn="last"
                    muiTablePaginationProps={{
                        rowsPerPageOptions: [3, 5, 10, 15, 20],
                        sx: { color: text.main, '& p': { marginBottom: 0 }, '& .MuiSvgIcon-root': { color: text.main, },}
                    }}
                    muiTableContainerProps={{
                        sx: {
                            padding: '0 !important',
                        }
                    }}

                    renderTopToolbar={({ table }) => {
                        const handleDeleteCustomers = () => {
                            handleDeleteBilledCustomer();
                            table.getSelectedRowModel().flatRows.map((row) => {
                                setSelectedBilledCustomers(current => [...current, row.original]);
                            });
                        };

                        return (
                            <>
                                {(isAccounting) ?
                                    (<div style={{ backgroundColor: primary.main, }}>
                                        <Button
                                            color="secondary"
                                            disabled={table.getSelectedRowModel().flatRows.length > 1 || table.getSelectedRowModel().flatRows.length === 0}
                                            onClick={handleDeleteCustomers}
                                            variant="contained"
                                            size="small"
                                            sx={{ mr: 1, ml: 1 }}
                                        >
                                            Delete Customer
                                        </Button>
                                        <Button onClick={resetBilledCustFilters} mr={2} variant="contained"
                                            sx={{
                                                '&:hover': {
                                                    backgroundColor: secondary.main,
                                                },
                                            }} color="secondary" size="small" startIcon={<RefreshIcon sx={{ backgroundColor: secondary.main }} size="small" />}>
                                            Reset Filters
                                        </Button>
                                    </div>) : (<></>)
                                }
                            </>
                        );
                    }}
                    renderRowActions={({ row }) => (
                        <div style={{ display: 'flex', flexWrap: 'nowrap', gap: '0.5rem' }}>
                            {(isAccounting || isSalesAdmin) ?
                                (<ButtonGroup variant="text" color="primary" size="small" aria-label="text primary button group">
                                    <Tooltip title="View" aria-label="Apply">
                                        <IconButton sx={{
                                            border: 1, borderRadius: 2, backgroundColor: secondary.main, borderColor: secondary.main, width: 30, height: 30,
                                            '&:hover': {
                                                backgroundColor: secondary.main,
                                            },
                                        }} color="text" size="small"
                                            onClick={() => {
                                                handleClickOpenBilledCustomerDetailView(row.original)
                                            }}
                                        >
                                            <VisibilityIcon style={{ backgroundColor: secondary.main }} size="small" />
                                        </IconButton>
                                    </Tooltip>
                                    &nbsp;&nbsp;
                                    <Tooltip title="Edit" aria-label="Rename Matrix">
                                        <IconButton sx={{
                                            border: 1, borderRadius: 2, backgroundColor: secondary.main, borderColor: secondary.main,
                                            width: 30, height: 30,
                                            '&:hover': {
                                                backgroundColor: secondary.main,
                                            },
                                        }} color="text" size="small"
                                            onClick={() => {
                                                handleBilledCustClickOpen(row.original)
                                            }}
                                        >
                                            <EditIcon style={{ backgroundColor: secondary.main }} size="small" />
                                        </IconButton>
                                    </Tooltip>
                                </ButtonGroup>
                                ) :
                                (<ButtonGroup variant="text" color="primary" size="small" aria-label="text primary button group">
                                    <Tooltip title="View" aria-label="Apply">
                                        <IconButton sx={{
                                            border: 1, borderRadius: 2, backgroundColor: secondary.main, borderColor: secondary.main, width: 30, height: 30,
                                            '&:hover': {
                                                backgroundColor: secondary.main,
                                            },
                                        }} color="text" size="small"
                                            onClick={() => {
                                                handleClickOpenBilledCustomerDetailView(row.original)
                                            }}
                                        >
                                            <VisibilityIcon style={{ backgroundColor: secondary.main }} size="small" />
                                        </IconButton>
                                    </Tooltip>
                                </ButtonGroup>
                                )
                            }
                        </div>
                    )}

                    filterFns={{
                        customerIdFilterFn: (row, _columnIds, filterValue) => {
                            if (filterValue !== null) {
                                if (filterValue !== 'All') {
                                    return String(row.getValue('customer_id')) === filterValue;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        },
                        customerNameFilterFn: (row, _columnIds, filterValue) => {
                            if (filterValue !== null) {
                                if (filterValue !== 'All') {
                                    return row.getValue('org_name') === filterValue;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        },
                        productTypeFilterFn: (row, _columnIds, filterValue) => {
                            if (filterValue !== null) {
                                if (filterValue !== 'All') {
                                    return row.getValue('product_type') === filterValue;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        },


                        statusFilterFn: (row, _columnIds, filterValue) => {
                            // console.log('nameFilterFn', row, row.original.is_active , filterValue);
                            // if (filterValue.length > 0) {
                            //     return filterValue.includes(row.getValue('is_active'))
                            // } else {
                            //     return true;
                            // }
                            if (filterValue === null || filterValue === undefined) return true;
                            return row.original.is_active === filterValue;
                        },


                    }}
                />
            }
            <Dialog
                open={openBilledCustDialog}
                onClose={handleBilledCustCloseDialog}
                // fullScreen={fullScreen}
                maxWidth={showProbeTable ? "lg" : "sm"}
                // scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                sx={{
                    '& .MuiDialog-paper': {
                        backgroundColor: primary.main,
                    }
                }}
            >
                <DialogTitle>
                    <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
                        {'Edit Billed Customer Details'}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} direction="row">
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>Customer Name</Typography>
                            <TextField
                                id="org_name"
                                name="org_name"
                                placeholder="Customer Name"
                                value={selectedRowBilledCust ? (selectedRowBilledCust.org_name !== null ? selectedRowBilledCust.org_name : '') : ''}
                                focused={false}
                                size='small'
                                slotprops={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                                disabled={true}
                                sx={{
                                    width: 200,
                                    color: text.main,
                                    borderColor: primary.focus,
                                    backgroundColor: transparent.main,
                                    borderRadius: borderRadius.md,
                                }}
                                onChange={handleBilledCustChange}
                            //fullWidth
                            //autoComplete="given-name"
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>Product Name</Typography>
                            <Select
                                fullWidth
                                sx={{ width: 200 }}
                                name="product_type"
                                value={productType || ''}
                                onChange={handleBilledCustProductTypeChange}
                            >
                                {productTypeList.map((item) => (
                                    <MenuItem
                                        key={item.product_id}
                                        value={item.product_type}
                                    >
                                        {item.product_type}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>
                                Account Status
                            </Typography>
                            <Select
                                fullWidth
                                name="is_active"
                                sx={{ width: 200 }}
                                value={selectedRowBilledCust && selectedRowBilledCust.is_active ? 'active' : 'inactive'}
                                // onChange={(e) => {
                                //     setSelectedRowBilledCust({
                                //         ...selectedRowBilledCust,
                                //         is_active: e.target.value === 'active'
                                //     });
                                // }}
                                onChange={handleBilledCustAccountStatusChange}
                                color="secondary"
                            >
                                <MenuItem value="active">Active</MenuItem>
                                <MenuItem value="inactive">Inactive</MenuItem>
                            </Select>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>
                                Account Type
                            </Typography>
                            <Select
                                fullWidth
                                sx={{ width: 200 }}
                                name="act_type"
                                // value={selectedRow?.act_type || ''}
                                value={selectedRowBilledCust && selectedRowBilledCust.act_type ? selectedRowBilledCust.act_type : ''}
                                // onChange={(e) => {
                                //     setSelectedRowBilledCust({
                                //         ...selectedRowBilledCust,
                                //         act_type: e.target.value
                                //     });
                                // }}
                                onChange={handleBilledCustAccountTypeChange}
                            >
                                <MenuItem value="demo">Demo</MenuItem>
                                <MenuItem value="billed">Billed</MenuItem>
                            </Select>
                        </Grid>
                    </Grid>
                    {showProbeTable && (
                        <>
                            <Divider sx={{ borderColor: primary.divider, mt: 2, mb: 2 }} />

                            <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 1 }}>
                                Probes Details
                            </Typography>

                            <Box sx={{ width: "100%" }}>
                                {probeStatusList.length > 0 ? (
                                    <ProbeStatus_table
                                        data={probeStatusList}
                                        getProbesByCustomerId={getProbesByCustomerId}
                                        selectedCustomer={selectedRowBilledCust}
                                    />
                                ) : (
                                    <Box m={4} p={4} sx={{ display: "flex", justifyContent: "center" }}>
                                        <Typography variant="body2" color={text.main} sx={{ fontWeight: 600 }}>
                                            No Probe Details
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </>
                    )}

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleBilledCustCloseDialog} color="secondary" variant="contained" sx={{ borderRadius: "4px", padding: "10px 20px", }}>
                        Cancel
                    </Button>
                    <Button onClick={handleOpenBilledCustConfirmation} color="secondary" disabled={!hasChangesForBilled()} variant="contained" sx={{ borderRadius: "4px", padding: "10px 20px", }}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            {/*
                     Updating data
                    */}

            <Dialog
                open={openBilledCustConfirmationDialog}
                onClose={handleCloseBilledCustConfirmation}
                fullScreen={fullScreen}
                // maxWidth={maxWidth}
                // scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                sx={{
                    '& .MuiDialog-paper': {
                        backgroundColor: primary.main,
                    }
                }}
            >
                <DialogTitle>
                    <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
                        {'Confirmation'}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    Are you sure you want to save the changes?
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseBilledCustConfirmation} color="secondary" variant="contained">
                        No
                    </Button>
                    <Button onClick={handleSaveBilledCust} color="secondary" variant="contained" >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openBilledCustViewDialog}
                onClose={handleCloseViewBilledCustomerDialog}
                fullScreen={fullScreen}
                // maxWidth={maxWidth}
                // scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                sx={{
                    '& .MuiDialog-paper': {
                        backgroundColor: primary.main,
                    }
                }}
            >
                <DialogTitle>
                    <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
                        {'View Billed Customer Details'}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} direction="row">
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>Customer Name</Typography>
                            <TextField
                                id="org_name"
                                name="org_name"
                                placeholder="Customer Name"
                                value={selectedRowBilledCust ? (selectedRowBilledCust.org_name !== null ? selectedRowBilledCust.org_name : '') : ''}
                                focused={false}
                                slotprops={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                                disabled={true}
                                sx={{
                                    width: 200,
                                    color: text.main,
                                    borderColor: primary.focus,
                                    backgroundColor: transparent.main,
                                    borderRadius: borderRadius.md,
                                }}

                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>Product Name</Typography>
                            <TextField
                                id="product_type"
                                name="product_type"
                                placeholder="Product Type"
                                value={productType || ''}
                                focused={false}
                                slotprops={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                                disabled={true}
                                sx={{
                                    width: 200,
                                    color: text.main,
                                    borderColor: primary.focus,
                                    backgroundColor: transparent.main,
                                    borderRadius: borderRadius.md,
                                }}

                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>
                                Account Status
                            </Typography>
                            <TextField
                                name="status"
                                // sx={{ width: 200 }}
                                value={selectedRowBilledCust && selectedRowBilledCust.is_active ? 'active' : 'inactive'}
                                focused={false}
                                slotprops={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                                disabled={true}
                                sx={{
                                    width: 200,
                                    color: text.main,
                                    borderColor: primary.focus,
                                    backgroundColor: transparent.main,
                                    borderRadius: borderRadius.md,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Typography variant="body2" fontSize={size.xs} color={text.main} sx={{ fontWeight: 400 }}>
                                Account Type
                            </Typography>
                            <TextField
                                name="account_type"
                                // value={selectedRow?.act_type || ''}
                                value={selectedRowBilledCust && selectedRowBilledCust.act_type ? selectedRowBilledCust.act_type : ''}
                                focused={false}
                                slotprops={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                                disabled={true}
                                sx={{
                                    width: 200,
                                    color: text.main,
                                    borderColor: primary.focus,
                                    backgroundColor: transparent.main,
                                    borderRadius: borderRadius.md,
                                }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseViewBilledCustomerDialog} color="secondary" variant="contained" sx={{ borderRadius: "4px", padding: "10px 20px", }}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={confirmDeleteOpenBilledCust}
                onClose={handleConfirmCloseBilledCust}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth='md'
                sx={{
                    '& .MuiDialog-paper': {
                        backgroundColor: primary.main,
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">
                    <Typography fontSize={size.lg} color={secondary.main} sx={{ fontWeight: 600, }}>{deleteMessageConfirmTitleBilledCust}</Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{deleteMessageConfirmBilledCust}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" startIcon={<CancelIcon />}
                        onClick={handleDeleteNoBilledCust}>No</Button>

                    <Button variant="contained" color="secondary" startIcon={<DeleteIcon />}
                        onClick={handleDeleteYesBilledCust} autoFocus>Yes</Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={showDeleteAlert}
                autoHideDuration={6000}
                key={vertical + horizontal}
                onClose={handleDeleteBilledCustAlertClose}
            >
                <Alert elevation={6} variant="filled" onClose={handleDeleteBilledCustAlertClose}
                    severity={pageAlertType || "error"} sx={{ "& .MuiAlert-message": { color: white.main, fontSize: size.sm }, marginBottom: 4 }}
                >
                    {deleteAlertMsg}
                </Alert>
            </Snackbar>
        </div>
    )
}

// export default BilledCustomers;
